import {Component} from "@angular/core";
import {InventoryGroupSearchModel} from "../inventory-group-search.model";
import {InventoryGroupEntityModel} from "../inventory-group-entity.model"
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-inventory-group-search-page",
    templateUrl: "./inventory-group-search-page.component.html",
    providers: [provideSearchModel(InventoryGroupSearchModel), provideEntityModel(InventoryGroupEntityModel)]
})
export class InventoryGroupSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
